// src/pages/logistica/ConfigLocalidadesAlmacen.jsx
import { useEffect, useState } from 'react';
import api from '../../services/api';

const NOMBRES = { PT: 'Producto Terminado', MP: 'Materia Prima / Empaque' };

export default function ConfigLocalidadesAlmacen() {
  const [filas, setFilas] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [guardandoAlmacen, setGuardandoAlmacen] = useState(null);
  const [mensaje, setMensaje] = useState(null);

  async function cargar() {
    try {
      setCargando(true);
      const res = await api.get('/api/logistica/ocupacion/config');
      setFilas(res.data.data);
    } catch (err) {
      console.error(err);
    } finally {
      setCargando(false);
    }
  }

  useEffect(() => { cargar(); }, []);

  function handleCambiar(almacen, valor) {
    setFilas((prev) => prev.map((f) => (f.almacen === almacen ? { ...f, total_localidades: valor } : f)));
  }

  async function handleGuardar(almacen) {
    const fila = filas.find((f) => f.almacen === almacen);
    try {
      setGuardandoAlmacen(almacen);
      setMensaje(null);
      await api.put(`/api/logistica/ocupacion/config/${almacen}`, { total_localidades: fila.total_localidades });
      setMensaje({ tipo: 'ok', texto: `✓ ${NOMBRES[almacen]} actualizado.` });
    } catch (err) {
      console.error(err);
      setMensaje({ tipo: 'error', texto: `No se pudo guardar ${almacen}.` });
    } finally {
      setGuardandoAlmacen(null);
    }
  }

  if (cargando) return <div style={styles.contenedor}>Cargando...</div>;

  return (
    <div style={styles.contenedor}>
      <h1 style={styles.titulo}>Localidades Totales por Almacén</h1>
      <p style={styles.subtitulo}>Usada para calcular Ocupación del Almacén — cámbiala si el almacén crece o se reorganiza.</p>

      {mensaje && <div style={{ ...styles.mensaje, color: mensaje.tipo === 'ok' ? '#3E7C5A' : '#B23A48' }}>{mensaje.texto}</div>}

      <div style={styles.tarjeta}>
        {filas.map((f) => (
          <div key={f.almacen} style={styles.fila}>
            <div style={styles.almacenNombre}>{NOMBRES[f.almacen] || f.almacen}</div>
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              <input
                type="number"
                min="1"
                value={f.total_localidades}
                onChange={(e) => handleCambiar(f.almacen, e.target.value)}
                style={styles.input}
              />
              <span style={styles.unidad}>localidades</span>
              <button onClick={() => handleGuardar(f.almacen)} disabled={guardandoAlmacen === f.almacen} style={styles.botonGuardar}>
                {guardandoAlmacen === f.almacen ? '...' : 'Guardar'}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

const styles = {
  contenedor: { fontFamily: 'Inter, sans-serif', padding: '24px', color: '#3A2E42', maxWidth: '560px' },
  titulo: { fontFamily: 'Playfair Display, serif', color: '#2A1830', marginBottom: '4px' },
  subtitulo: { fontSize: '12px', color: '#8A7690', marginBottom: '18px' },
  mensaje: { fontSize: '13px', marginBottom: '14px', fontWeight: 600 },
  tarjeta: { background: '#fff', border: '1px solid #E6DDD2', borderRadius: '12px', padding: '18px', boxShadow: '0 2px 14px rgba(74,30,92,0.07)', display: 'flex', flexDirection: 'column', gap: '14px' },
  fila: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '14px', paddingBottom: '14px', borderBottom: '1px solid #F0E9E0' },
  almacenNombre: { fontSize: '14px', fontWeight: 700, color: '#2A1830', minWidth: '160px' },
  input: { width: '90px', padding: '7px 10px', fontSize: '13px', border: '1px solid #D6A644', borderRadius: '6px', fontFamily: 'Inter, sans-serif', background: '#FFFDF7' },
  unidad: { fontSize: '11px', color: '#8A7690' },
  botonGuardar: { padding: '6px 14px', fontSize: '12px', fontWeight: 600, color: '#6E4F80', background: '#EFE9F3', border: '1px solid #A98BB8', borderRadius: '6px', cursor: 'pointer' },
};